<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { CheckCircle, ExclamationCircle, Folder, FolderOpen, Icon } from 'svelte-hero-icons'

	import { goto } from '$app/navigation'
	import { page } from '$app/stores'
	import { getDateTimeShortFormat, humanizeDateTime } from '$lib/datetimes'

	export let event: any = {}
	export let dismissEnabled = true

	const dispatch = createEventDispatcher()

	let displayHumanizeFormat = true
	let dateFormatted = humanizeDateTime(event.created_at)

	$: dateFormatted = getDateFormatted(event.created_at, displayHumanizeFormat)

	const getDateFormatted = (d: string, displayHumanizeFormat: boolean) => {
		//console.log("server date:",d)

		let dh = humanizeDateTime(d)

		if (displayHumanizeFormat) return dh
		else return getDateTimeShortFormat(d)
	}


	const handleDismissEvent = () => {
		dispatch('event_dismiss')
	}

	const handleInsideDate = (inside: boolean) => {
		displayHumanizeFormat = inside
	}

	const handleLink = (evtLink: any) => {
		// console.log( 'handleLink', evtLink )
		if (evtLink.link !== $page.url) goto(evtLink.link)
		dispatch('events_close')
	}
</script>

<!--  {#if event.state !== 'archived'} -->
<!-- This example requires Tailwind CSS v2.0+ -->
<!-- Global notification live region, render this permanently at the end of the document -->
<!-- <div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end"> -->
<!--
        Notification panel, dynamically insert this into the live region when it needs to be displayed
  
        Entering: "transform ease-out duration-300 transition"
          From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          To: "translate-y-0 opacity-100 sm:translate-x-0"
        Leaving: "transition ease-in duration-100"
          From: "opacity-100"
          To: "opacity-0" 
      -->
<!-- <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"> -->
<div class="p-4 border-gray-200">
	<div class="flex items-start">
		<div class="flex-shrink-0">
			{#if event.state === 'viewed'}
				<Icon src={FolderOpen} class="w-6 h-6 text-gray-400 cursor-pointer" />
			{:else}
				<Icon src={Folder} class="w-6 h-6 text-gray-700 cursor-pointer" />
			{/if}
			{#if event.type === 'warning'}
				<Icon
					src={ExclamationCircle}
					class="relative w-5 h-5 -top-3 left-3 bg-white text-yellow-400 cursor-pointer"
				/>
			{:else}
				<Icon
					src={CheckCircle}
					class="relative w-5 h-5 -top-3 left-3 bg-white text-green-400 cursor-pointer"
				/>
			{/if}
		</div>
		<div class="ml-3 w-0 flex-1 pt-0.5">
			<div class="text-sm text-gray-900 flex">
				<span class="font-medium whitespace-nowrap">{event.title}</span>
				<div
					class="w-full grid justify-items-end"
					on:mouseenter={() => handleInsideDate(false)}
					on:mouseleave={() => handleInsideDate(true)}
				>
					<span class="whitespace-nowrap">{dateFormatted}</span>
				</div>
			</div>

			<p class="mt-1 text-sm text-gray-500">{event.body}</p>

			<!-- Links -->
			{#if event.links.length > 0}
				<div class="mt-3 flex space-x-7">
					{#each event.links as link, i}
						<!-- <button type="button" class="bg-white rounded-md text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">{link.name}</button> -->
						<a
							href="/"
							on:click|preventDefault={() => handleLink(link)}
							class="bg-white rounded-md text-sm font-medium text-blue-500 hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
							>{link.name}</a
						>
					{/each}
				</div>
			{/if}
		</div>
		<div class="ml-4 flex-shrink-0 flex">
			{#if dismissEnabled}
				<button
					on:click={() => handleDismissEvent()}
					type="button"
					class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
				>
					<span class="sr-only">Close</span>
					<!-- Heroicon name: solid/x -->
					<svg
						class="h-5 w-5"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						aria-hidden="true"
					>
						<path
							fill-rule="evenodd"
							d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
							clip-rule="evenodd"
						/>
					</svg>
				</button>
			{/if}
		</div>
	</div>
</div>
<!-- {/if} -->
